import React from 'react';
import { motion } from 'framer-motion';
import { Braces, Stethoscope, Shield, Cpu } from 'lucide-react';

const focusAreas = [
    {
        title: "AI-native applications",
        description: "From agentic systems to vertical AI copilots and multimodal UX, we invest where product workflows transform markets, not just interfaces. We provide flexible capital access to accelerate GTM.",
        icon: <Braces className="w-7 h-7 text-white" />,
        iconBg: "bg-blue-500"
    },
    {
        title: "AI in healthcare and science",
        description: "Translational AI for discovery, diagnostics, and care delivery—where data advantage and clinical-grade rigor convert into outcomes. Optimized capital solutions reduce dilution during long regulatory paths.",
        icon: <Stethoscope className="w-7 h-7 text-white" />,
        iconBg: "bg-pink-500"
    },
    {
        title: "Developer tools and security",
        description: "Build and ship faster with reliable platforms, safety, and governance—accelerants that unlock adoption across industries. Amama Bypass helps secure non-dilutive runway.",
        icon: <Shield className="w-7 h-7 text-white" />,
        iconBg: "bg-orange-500"
    },
    {
        title: "Infrastructure and compute",
        description: "From data plumbing to inference stacks and novel compute architectures, we back teams pushing the limits of performance and cost curves. Capital support is tailored for intensive CapEx needs.",
        icon: <Cpu className="w-7 h-7 text-white" />,
        iconBg: "bg-green-500"
    }
];

const FocusStripes = () => {
    return (
        <section id="our-focus" className="bg-background py-24 md:py-32">
            <div className="container mx-auto px-6">
                <h2 className="text-4xl md:text-5xl font-bold text-center bg-gradient-primary bg-clip-text text-transparent">Our Focus</h2>
                <p className="text-xl text-muted-foreground max-w-2xl mx-auto text-center mt-4">
                    Backing application-layer AI, devtools/security, and compute/infrastructure that compound over a decade.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16 max-w-6xl mx-auto">
                    {focusAreas.map((area, index) => (
                        <motion.div
                            key={area.title}
                            className="bg-card p-8 rounded-lg shadow-medium transition-all duration-500 border-2 border-border hover:border-secondary/50 hover:shadow-strong group"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                        >
                            <div className={`w-14 h-14 rounded-xl flex items-center justify-center ${area.iconBg} mb-6`}>
                                {area.icon}
                            </div>

                            <h3 className="text-2xl font-bold text-card-foreground group-hover:text-primary mb-4 transition-colors duration-500">
                                {area.title}
                            </h3>

                            <p className="text-base text-muted-foreground leading-relaxed">{area.description}</p>

                            <div className="mt-6 h-1 w-0 bg-gradient-accent group-hover:w-full transition-all duration-500 rounded-full"></div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FocusStripes;